// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { HireCreditLimit } = require('components/hire/hireCreditLimit/hireCreditLimit');
const { HirePaymentMethod } = require('components/hire/hirePaymentMethod/hirePaymentMethod');
import { DisclaimerPersonalInfo } from 'components/hire/cardViaT/disclaimerPersonalInfo/disclaimerPersonalInfo';

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');
// @ constants
const {
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_REPRESENTATIVE,
    CHECKING_ACCOUNT_CODE,
    EURO_TEXT,
    THIRD_STEP,
    WIZARD_THIRD_STEP
} = require('constants/index');
const {
    ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES
} = require('constants/accounts');
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');

class HireCardNerudaStep3 extends React.Component {
    constructor(props) {
        super(props);

        this.onCreditLimitModalContinue = this.onCreditLimitModalContinue.bind(this);
    }

    componentDidMount() {
        const { immAccounts, setAllAccountsToInactive } = this.props;
        const allAccountsInactive = hasAllAccountsInactive(this.filterAccounts(), immAccounts.get('byId'));
        if (allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    onCreditLimitModalContinue() {
        const {
            immHireCreditLimit,
            setHireCreditLimit,
            toggleCreditLimitModal,
            validate,
        } = this.props;

        setHireCreditLimit(immHireCreditLimit.get('creditLimitModalValue'), true);
        toggleCreditLimitModal(false);
        validate(WIZARD_THIRD_STEP, true);
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const interventionTypes = [
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
            ACCOUNT_INTERVENTION_REPRESENTATIVE
        ];
        const accountsIndexes = immAccounts.get('byOrder').filter( accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter( accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter( accountId =>
            // We remove the accounts where the user is not the owner
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    render() {
        const {
            getContextTranslate,
            handleAccountChange,
            immAccounts,
            immFlagBasedFeatures,
            immGlobalVariables,
            immHireCardImageSelector,
            immHireCardNeruda,
            immHireCreditLimit,
            immHirePaymentMethod,
            isInactiveAccountsEnabled,
        } = this.props;
        const immStep3 = immHireCardNeruda.getIn(['steps', THIRD_STEP]);
        const accountErrorMsgVisible = immStep3.get('accountIsDirty') && !immStep3.get('accountIsValid');
        const accountErrorMsg = formatText(getContextTranslate('step3SelectAccountError'));
        const accountLabel = formatText(getContextTranslate('step3SelectAccount'));

        const disclaimerPersonalInfoUrl = formatText(getContextTranslate('disclaimerPersonalInfoLinkUrlNeruda'));

        const selectedImageId = immHireCardImageSelector.get('selectedImageId');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        return (
            <article className="hire-card-neruda-step-three">
                <FormattedText
                    className="hire-card-neruda__step-title"
                    value={getContextTranslate('step3Title')}
                />
                <DropdownAccounts
                    accountsIndexes={this.filterAccounts()}
                    currentAccountId={immStep3.get('accountId')}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    label={accountLabel}
                    loading={isBlockedAccountsLoading}
                    onAccountChange={handleAccountChange}
                    optionalElement={DisclaimerPersonalInfo()}
                    showAvailableBalance
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                />
                <h4 className="hire-card-neruda__section-header">
                    <FormattedText value={getContextTranslate('step3CardData')} />
                </h4>
                <HireCreditLimit
                    handleModalContinue={this.onCreditLimitModalContinue}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    productSubType={immHireCardNeruda.get('subtype')}
                    productType={immHireCardNeruda.get('type')}
                    referenceStandard={`0000${selectedImageId.substring(10)}`}
                />
                <HirePaymentMethod
                    immCreditLimit={immHireCreditLimit}
                    immGlobalVariables={immGlobalVariables}
                    immHirePaymentMethod={immHirePaymentMethod}
                    isNerudaCard={true}
                />
                {!immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS) &&
                    <OKMessage type="informative">
                        <FormattedText value={getContextTranslate('disclaimerPersonalInfoMsgNeruda')} />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value={getContextTranslate('disclaimerPersonalInfoLinkTextNeruda')} />
                        </OKLink>
                    </OKMessage>
                }
            </article>
        );
    }
}

HireCardNerudaStep3.propTypes = {
    getContextTranslate: PropTypes.func.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNeruda: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
};

module.exports = HireCardNerudaStep3;
